/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { render } from 'react-dom';
import { InertiaApp } from '@inertiajs/inertia-react';
import { PolarisVizProvider } from '@shopify/polaris-viz';
import Toastify from 'js/Shared/ToastContainer';
// eslint-disable-next-line import/no-unresolved
import { Widget } from 'Shared/Widget';
import {
  enhacePageStateHandler, getEndPoints, init, parseComponentName,
} from './util';

const root = document.getElementById('app');

init();

export const AppContext = React.createContext();

function App() {
  const [inertiaPage, setInertiaPage] = React.useState(JSON.parse(root.dataset.page));
  const [hasUnsavedChanges, setHasUnsavedChanges] = React.useState(false);
  const [isNavigationBlocked, setIsNavigationBlocked] = React.useState(false);
  const onPageChange = React.useCallback(enhacePageStateHandler(setInertiaPage), []);

  const canShowWidget = getEndPoints(window.location.href).includes('/login');

  const context = {
    hasUnsavedChanges,
    setHasUnsavedChanges,
    isNavigationBlocked,
    setIsNavigationBlocked,
  };

  return (
    <AppContext.Provider value={context}>
      <PolarisVizProvider>
        <Toastify page={inertiaPage} />
        <InertiaApp
          initialPage={inertiaPage}
          resolveComponent={parseComponentName}
          onPageChange={onPageChange}
        />
        {!canShowWidget && <Widget />}
      </PolarisVizProvider>
    </AppContext.Provider>
  );
}

render(<App />, root);
